import { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import GatewaySensorModalAction from '../Components/GatewaySensor/GatewaySensorModalAction';
import HEADER from "../Components/header";
import { useCookies } from 'react-cookie';
import { useForm, SubmitHandler } from 'react-hook-form';
import baseUrlApi from '../lib/baseUrlApi';
import { Link } from 'react-router-dom';
import BACK from '../images/icon-back-b.svg';
import {ApiRequest} from "../Consts/ApiRequest";


type GatewayInputs = {
  gatewayRecno: number;
  controlID: string;
  noise: {
    sensorId: string;
    sensorRecno: number;
  };
  env: {
    sensorId: string;
    sensorRecno: number;
  };
  sui: {
    sensorId: string;
    sensorRecno: number;
  },
  contactEnd: string;
  gatewayAdminNum: string;
};
type GatewayInfo = {
  siteRecno: string;
  siteId: string;
  contactEnd: string;
  gatewayCount: number;
  gateways: GatewayInputs[]
};
type SensorData = {
  "sensorRecno": number;
  "sensorID": string,
  "sensorName": string,
  "sensorKind": number,
  "assigned": boolean
};
type Param = {
  siteId?: string,
  siteRecno?: string
}
const GatewaySensor = (props: any) => {
  const navigate = useNavigate();
  const [gatewayInfo, setGatewayInfo] = useState<GatewayInfo>({
    siteId: "",
    siteRecno: "",
    contactEnd: "",
    gatewayCount: 0,
    gateways: []
  });
  const [sensorInfo, setSensorInfo] = useState<SensorData[]>([]);
  const [noise, setNoise] = useState<string>("");
  const [env, setEnv] = useState<string>("");
  const [sui, setSui] = useState<string>("");
  const [getGatewayData, setGetGatewayData] = useState<GatewayInputs[]>([]);
  const [contactEnd, setContactEnd] = useState<string>("");
  const [controlID, setcontrolID] = useState<string>("");
  const [gatewayCount, setGatewayCount] = useState<number>(0);
  const [state, setState] = useState("aaaaaaaa")
  const { register, handleSubmit, formState: { errors } } = useForm<GatewayInputs>();
  const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
  const params: Param = useParams<Param>();
  const [siteId, setSiteId] = useState<string>(params.siteId ?? "");
  const siteRecno = params.siteRecno ?? "";

  const changeState = (isState: string) => {
    setState(isState)
    getGatewaySensor();
  }

  function errorCallback(error:any){
    if (error.response && error.response.status === 401) {
      console.error("Error token error:", error);
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
    }
    console.error("Error fetching dataSite:", error);
  }

  /**
   * センサー情報の取得（選択肢用）
   */
  const getSensor = () => {
    let params = {
      "sensorInfo": sensorInfo,
      "prcKind": 0,
      "assigned": false
    };

    const token = cookies.access_token || "";
    ApiRequest.getSensor(params, token, (response:any)=>{
      if (response.data) {
        // console.log(response.data.sensors)
        setSensorInfo(response.data.sensors);
        // console.log(sensorInfo)
      } else {
        console.error('Data is not an array:');
      }
    }, (error:any) => {
      errorCallback(error)
    })
  }

  /***
   * ゲートウェイ情報（選択肢用）の取得
   */
  const getGatewayList = (initFlag:boolean = false) =>{
    let params = {
      prcKind: 1,
      deviceInfo: {
        gatewayRecno: "",
        controlID: "",
        gatewayID: "",
        serialNO: "",
        assigned: false
      }
    };

    const token = cookies.access_token || "";
    ApiRequest.getGateway(params, token, (response:any)=>{
        setGetGatewayData(response.data.devices);
    }, (error: any) => {
      errorCallback(error);
    });

  }

  /**
   * ゲートウェイ情報（一覧表示用）の取得
   */
  const getGatewaySensor = () => {
    let params = {
      "prcKind": 0,
      "siteRecno": siteRecno,
      "siteId": siteId,
      "noise": {
        "sensorId": ""
      },
      "sui": {
        "sensorId": ""
      },
      "env": {
        "sensorId": ""
      }
    };

    const token = cookies.access_token || "";
    ApiRequest.getGatewaySensor(params, token,(response:any) => {
      setGatewayCount(response.data.gatewayCount ?? 0);
      if (Array.isArray(response.data.gateways)) {
        setGatewayInfo(response.data);
      } else {
        console.error('Data is not an array:', response.data);
      }
    }, (error: any)=> {
      errorCallback(error);
    });
  }

  const closeEditModal = () => {
    getGatewaySensor();
    getSensor();
    getGatewayList();

  };

  useEffect(() => {
    if(cookies.authority == 3 || cookies.authority == 4) {
      removeCookie('access_token', {path: '/'});
      removeCookie('authority', {path: '/'});
      removeCookie('siteId', {path: '/'});
      removeCookie('siteRecno', {path: '/'});
      navigate("logout");
  }
    getGatewaySensor();
    getSensor();
    getGatewayList();
  }, []);

  const controlIDs = getGatewayData.map(item => item.controlID);
  // console.log(controlIDs);
  const gatewayRecnos = getGatewayData.map(item => item.gatewayRecno);

  const onSubmitSearch: SubmitHandler<GatewayInputs> = async (data) => {

    try {
      let params:any = {
        "prcKind": 1,
        "siteId": siteId,
        "siteRecno": siteRecno,
        "contactEnd": contactEnd,
        "controlID": controlID,
        "noise": {
          "sensorId": ""
        },
        "sui": {
          "sensorId": ""
        },
        "env": {
          "sensorId": ""
        }
      };
      if(controlID){
        params.gatewayID = controlID;
      }
      if(noise){
        params.noise = { "sensorId": noise };
      }
      if(env){
        params.env = { "sensorId": env };
      }
      if(sui){
        params.sui = { "sensorId": sui };
      }

      const token = cookies.access_token || "";
      ApiRequest.getGatewaySensor(params, token, (response:any)=> {
        if (Array.isArray(response.data.gateways)) {
          console.log(response.data.gateways)
          setGatewayInfo(response.data);
        } else {
          console.error('Data is not an array:', response.data);
        }
      },(error:any)=>{
        errorCallback(error);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const gatewaySensorProps = {
    siteId: siteId,
    siteRecno: siteRecno,
    controlIDs: controlIDs,
    sensors: sensorInfo,
    gatewayRecnos: gatewayRecnos,
    gateways: gatewayInfo.gateways,
    getGatewayData: getGatewayData,
    getGatewaySensor: closeEditModal
  };

  return (
    <div>
      <div className="wrapper">
        <HEADER />
        <main className="main">

          <section className="page-head" id="page-head">
            <div className="page-head-block">
              <div className="page-name">
                <a onClick={() => navigate(-1)}>
                  <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" />
                </a>
                <div className="page-name-label">Gateway、センサ一覧</div>
              </div>
              <div className="page-option">
                {cookies.authority == 2 ?
                  <GatewaySensorModalAction
                    {...gatewaySensorProps}
                    prcKind={0}
                    siteId={""}
                    gatewayRecno={0}
                    contactEnd={""}
                    controlID={""}
                    noiseSensorRecno={0}
                    envSensorRecno={0}
                    suiSensorRecno={0}
                  />
                  :<></>
                }
              </div>
            </div>
            <div className="page-head-block">
              <div className="page-info-box">
                <div className="page-info-item">
                  <span className="page-info-label">現場ID</span>{siteId}
                </div>
                <div className="page-info-item">
                  <span className="page-info-label">Gateway登録数</span>
                  {gatewayCount}
                </div>
              </div>
            </div>
          </section>

          <section className="page-body scroll-block">
            <form onSubmit={handleSubmit(onSubmitSearch)}>
              <div className="search-box">
                <div className="search-box-elm">
                  <div className="search-box-elm-name">Gateway管理番号</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={controlID}
                      placeholder="Gateway管理番号"
                      {...register("controlID",)}
                      className={(errors.controlID ? "error-disp" : "")}
                      onChange={e => setcontrolID(e.target.value)}
                    />
                    {errors.controlID && <p className="error-msg">{errors.controlID?.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">騒音振動</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={noise}
                      placeholder="noise SensorId"
                      {...register("noise",)}
                      className={" " + (errors.noise ? "error-disp" : "")}
                      onChange={e => setNoise(e.target.value)}
                    />
                    {errors.noise && <p className="error-msg">{errors.noise.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">気象</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={env}
                      placeholder="env SensorId"
                      {...register("env",)}
                      className={"col-320" + (errors.env ? "error-disp" : "")}
                      onChange={e => setEnv(e.target.value)}
                    />
                    {errors.env && <p className="error-msg">{errors.env.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">水位</div>
                  <div className="search-box-elm-input">
                    <input
                      type="text"
                      value={sui}
                      placeholder="sui SensorId"
                      {...register("sui",)}
                      className={"col-320" + (errors.sui ? "error-disp" : "")}
                      onChange={e => setSui(e.target.value)}
                    />
                    {errors.sui && <p className="error-msg">{errors.sui.message}</p>}
                  </div>
                </div>
                <div className="search-box-elm">
                  <div className="search-box-elm-name">契約終了日</div>
                  <div className="search-box-elm-input">
                    <input
                      type="date"
                      value={contactEnd}
                      min="0000-01-01"
                      max="9999-12-31"
                      {...register("contactEnd",)}
                      className={"col-320 " + (errors.contactEnd ? "error-disp" : "")}
                      onChange={e => setContactEnd(e.target.value)}
                    />
                    {errors.contactEnd && <p className="error-msg">{errors.contactEnd.message}</p>}
                  </div>
                </div>
                <div className="search-box-btn">
                  <button className="btn btn-white-line" type="submit" >
                    <i className="icon-search-w"></i>検索
                  </button>
                </div>
              </div>
            </form>
            <div className="table-box">
              <table className="st-table">
                <thead>
                  <tr>
                    <th className="">Gateway管理番号</th>
                    <th className="">騒音振動</th>
                    <th className="">気象</th>
                    <th className="">水位</th>
                    <th className="">契約終了日</th>
                    {cookies.authority == 2 &&
                      <th className="col-100">編集</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {gatewayInfo.gateways.map((item, index) => (
                    <tr key={item.controlID}>
                      <td
                        className="nowrap"
                      >
                        <Link to={`/dashboard/${siteId}/${siteRecno}`} className={"list-link"}>

                          {item.controlID}
                        </Link>
                      </td>
                      <td className="nowrap">{item.noise.sensorId}</td>
                      <td className="nowrap">{item.env.sensorId}</td>
                      <td className="nowrap">{item.sui.sensorId}</td>
                      <td className="nowrap">{item.contactEnd}</td>
                      <td>
                        {cookies.authority == 2 &&
                          <GatewaySensorModalAction
                            {...gatewaySensorProps}
                            prcKind={1}
                            noise={item.noise}
                            env={item.env}
                            sui={item.sui}
                            gatewayRecno={item.gatewayRecno}
                            contactEnd={item.contactEnd}
                            controlID={item.controlID}
                            siteId={siteId}
                            siteRecno={siteRecno}
                            noiseSensorRecno={item.noise.sensorRecno ?? 0}
                            envSensorRecno={item.env.sensorRecno ?? 0}
                            suiSensorRecno={item.sui.sensorRecno ?? 0}
                          />
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </main>
      </div>
    </div>
  )
};
export default GatewaySensor;
